import { useState } from "react"

export const useGlobalStates = () => {

    // formulario de datos (pantalla/modal de edición/ver datos)
    const [showForm, setShowForm] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE') // EDITABLE | READONLY

    // modal/pantalla de imágenes (solo imágenes)
    const [showModalCollateralImages, setShowModalCollateralImages] = useState(false)
    const [collateralIdImages, setCollateralIdImages] = useState(0)

    // modo para la sección de imágenes (también aplica READONLY/EDITABLE)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')

    // navegación general: qué sección/feature estás mostrando
    // HOME | DATOS | IMAGENES (podés renombrarlo como querrás)
    const [showSection, setShowSection] = useState('HOME')

    // navegación de imágenes
    const [imagesCurrentIndex, setImagesCurrentIndex] = useState(0)

    // opcional: para abrir directamente desde el dropdown
    // 'NONE' | 'DATA' | 'IMAGES'
    const [openTarget, setOpenTarget] = useState('NONE')

    return Object.freeze({
        // datos
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,

        // imágenes
        showModalCollateralImages, setShowModalCollateralImages,
        collateralIdImages, setCollateralIdImages,
        modalOpeningMode, setModalOpeningMode,

        // navegación
        showSection, setShowSection,
        imagesCurrentIndex, setImagesCurrentIndex,

        // opcional
        openTarget, setOpenTarget,
    })
}